<template>
  <div class="sjcj">
    <div class="card1">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t11">大模型数据服务</div>
          <div class="t22">
            我们支持全栈式大模型数据服务，包括数据集，模型评估，模型调优；同时，我们大模型智能开发平台与全套标注工具支持您快速部署大模型应用。
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="w1280" style="margin: 48px auto;">
        <div class="title">大模型应用落地全面支持</div>
        <div class="slogan">
          通过人机协同方式进行LLM微调，企业可以让模型更适应具体的用例，获得竞争优势。我们支持您的大模型定制开发全流程需求，助您轻松拥抱大模型。
        </div>
        <div class="flexs">
          <div style="width: 55%;">
            <div class="title-11">大模型数据集</div>
            <div class="title-22">
              提供多模态，多领域，多场景的数据集以供各类模型各阶段训练。
            </div>
            <div class="title-11">模型评估服务</div>
            <div class="title-22">
              提供模型人工评估服务，可视化数据呈现模型效果，bad case 一览无余。
            </div>
            <div class="title-11">模型调优服务</div>
            <div class="title-22">
              提供通过 prompt 工程，模型精调，RAG 等方式实现的模型调优，提供更贴合使用场景的大模型。
            </div>
            <div class="title-11">训练平台部署</div>
            <div class="title-22">
              提供覆盖大模型训练全周期的训练平台部署。
            </div>
            <div class="title-11">标注工具部署</div>
            <div class="title-22">
              提供专业高效的大模型训练数据标注工具部署。
            </div>
          </div>
          <div style="width: 40%;">
            <img
              style="width: 100%;border-radius:16px"
              src="../assets/img/sjfw/g1.webp"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">涵盖多垂直领域</div>

      <div class="w1280" style="margin-top:48px">
        <div class="flexs" style="flex-wrap: wrap;">
          <div class="card-sx" v-for="(item, index) in cardList" :key="index">
            <div class="contents">
              <div class="img-sx">
              <img style="width: 48px;height: 48px;margin-bottom: 12px;" :src="item.img" alt="" />
            </div>
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">成功案例</div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">多模态大模型数据解决方案</div>
            <div style="line-height: 1.5;font-size: 18px;margin-bottom: 48px;">
              基于其大模型平台的多模态数据处理能力，为某 AI 科技厂商提供图像文本描述数据服务。我们为客户提供了超过50亿对高质量图文对，为客户的图文大模型提供了充足的数据支持。同时，我们还为数个多模态大模型项目提供高质量数据服务，涵盖文本、图像、视频、音频等多种不同模态的数据类型。
            </div>
           
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/y2.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/y1.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">垂类大模型数据解决方案</div>
            <div style="line-height: 1.5;font-size: 18px;margin-bottom: 48px;">
              基于其大模型平台的多模态数据处理能力，为某 AI 为某科技公司提供大规模代码类大模型训练数据解决方案。利用我们的定制模板引擎和多模态数据编辑器，聚集了行业专家团队，包括各种开发语言的研发工程师、数据分析师和算法工程师，提供高质量的代码训练数据。覆盖了代码编写、逻辑解析、代码调试和单元测试等各个阶段的数据需求，累计提供了50万组以上的高质量代码数据，为代码大模型的应用提供了可靠数据支持。
            </div>
           
          </div>
          
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">我们的优势</div>
      <div class="w1280" style="">
        <div class="flexs" style="flex-wrap: wrap;margin:32px 128px">
          <div class="card-ys" v-for="(item, index) in ysList" :key="index">
            <img
              style="width:48px;height:48px;margin-bottom:8px"
              :src="item.img"
              alt=""
            />
            <div class="t1">{{ item.name }}</div>
            <div class="t2">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="t1">大模型全流程服务</div>
      <div class="t2">涵盖多语言全开发流程的大模型数据服务</div>
      <div class="btns" @click="go('/callMe')">联系我们</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ysList: [
        {
          name: "专业度",
          content:
            "28+年数据行业深耕，支持众多AI项目落地，为您提供全面快速的数据支持。",
          img: require("../assets/img/sjfw/e1.svg"),
        },
        {
          name: "垂类经验（行业资源）",
          content:
            "多行业专业团队支持，包括代码、医疗、教育等，支持您的用例数据需求。",
          img: require("../assets/img/sjfw/e2.svg"),
        },
        {
          name: "及时响应 / 任务切换能力",
          content:
            "全球资源的调配及平台技术的支持，快速响应的售前及售后服务团队，确保项目快速准备和部署。",
          img: require("../assets/img/sjfw/e3.svg"),
        },
        {
          name: "安全合规性",
          content:
            "安全设备、现场服务、安全众包模型和技术解决方案已经通过 ISO 27001，ISO 27701，ISO 9001，GDPR，SOC 2 类型II 认证，及 HIPPA 认证。",
          img: require("../assets/img/sjfw/e4.svg"),
        },
      ],
      cardList1: [
        {
          name: "数据存储与传输",
          list: [
            { t: "国安级加密云技术保证数据传输和存储安全" },
            {
              t:
                "业界领先的Appen Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别",
            },
          ],
          img: require("../assets/img/sjfw/x1.svg"),
        },
        {
          name: "项目现场与监管",
          list: [
            { t: "项目现场配置人脸识别和指纹门禁" },
            {
              t:
                "设有加密项目房间，仅授权人员准许进入 Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别",
            },
            { t: "配有24*7值班人员以及无死角摄像头监控现场" },
          ],
          img: require("../assets/img/sjfw/x2.svg"),
        },
        {
          name: "雇员与被采人管控",
          list: [
            { t: "标注人员及供应商签署保密协议" },
            { t: "全体员工办公设备均统一管理" },
          ],
          img: require("../assets/img/sjfw/x3.svg"),
        },
      ],
      cardList: [
        {
          title: "医疗",
          img: require("../assets/img/sjfw/t1.svg"),
          textList: [
            {
              title: "",
              content:
                "医学药学知识数据库，医学专业人员协同进行模型评估与调优支持。",
            },
          ],
        },
        {
          title: "金融",
          img: require("../assets/img/sjfw/t2.svg"),
          textList: [
            {
              title: "",
              content:
                "庞大数据库支持，专业名词释义评估，以及金融趋势分析判断。",
            },
          ],
        },
        {
          title: "教育",
          img: require("../assets/img/sjfw/t3.svg"),
          textList: [
            {
              title: "",
              content: "多学科公式及知识支持，包括思维链标注，Prompt 撰写，以及评估打分。",
            }
          ],
        },
        {
          title: "代码",
          img: require("../assets/img/sjfw/t4.svg"),
          textList: [
            {
              title: "",
              content: "专业技术团队，进行代码有效性评估、内容整理与判断。",
            }
          ],
        },
        {
          title: "法律",
          img: require("../assets/img/sjfw/t5.svg"),
          textList: [
            {
              title: "",
              content: "法律垂类数据库，专业团队进行思维链分析，答案判断及改写。",
            }
          ],
        },
       
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.sjcj {
  .card1 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 370px;
  }
  .card4 {
    width: 1280px;
    margin: 48px auto;
    text-align: center;
    .item-card2 {
      flex-shrink: 0;
      text-align: center;
      width: 340px;
      margin: 40px 30px;
    }
    .item-card {
      height: 240px;
      flex-shrink: 0;
      padding: 40px 24px;
      background-color: #eceff0;
      border-radius: 8px;
      width: 360px;
      margin-top: 20px;
      text-align: left;
      font-size: 16px;
    }
    .select-tab {
      margin: 30px 0 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 38px;
      line-height: 38px;
      align-content: center;
      padding: 2px;
      border-radius: 25px;
      border-width: 1px;
      border-style: solid;
      border-color: #000;
      border-image: initial;
      .s-tabs {
        width: 20%;
        height: 38px;
        text-align: center;
        cursor: pointer;
        border-radius: 25px;
      }
      .is-active {
        color: rgb(255, 255, 255);
        background: #045588;
      }
    }
    .card4-t1 {
      color: #045588;
      font-size: 48px;
      font-weight: bold;
    }
    .card4-t2 {
      font-size: 16px;
      width: 680px;
      margin: 24px auto 0;
      line-height: 1.5;
    }
    .card4-t3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 56px;
      color: #045588;
      font-weight: bold;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 150px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card2 {
    width: 1280px;
    margin: 0 auto;
    .card-ys {
      width: 448px;
      height: 178px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top: 24px;
      .t1 {
        font-size: 20px;
        color: #25282a;
        margin-bottom: 16px;
      }
      .t2 {
        font-size: 16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 200px;
      
      margin: 0 0 48px;
      .contents {
        padding: 24px;
        height: 228px;
        background-color: #eceff0;
        border-radius: 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          line-height: 1.5;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card-footer {
    width: 100%;
    height: 328px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .t1 {
      color: rgb(0, 126, 204);
      font-weight: 500;
      font-size: 50px;
      text-align: center;
      padding-top: 60px;
    }
    .t2 {
      text-align: center;
      margin-top: 24px;
    }
    .btns {
      text-align: center;
      background-image: linear-gradient(
        260.38deg,
        #099fee 3.89%,
        #2247da 143.13%
      );
      width: 96px;
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
      border-radius: 8px;
    }
  }
  .btn1 {
    width: 250px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background-color: #099fee;
    border-radius: 8px;
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t11 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t22 {
      margin: 32px 256px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
    .title-1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
    }
    .title-2 {
      font-size: 16px;
      line-height: 1.5;
    }
    .title-11{
      font-size: 28px;
      color: #444;
      line-height: 2;
      font-weight: 600;
    }
    .title-22{
      font-size: 16px;
      color: #4b4f54;
      line-height: 1.5;
      margin-bottom: 16px;
    }
    li {
      margin-left: 24px;
      line-height: 1.5;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style></style>
